module.exports = __webpack_public_path__ + "static/Logo Jack Richards-194592d1cb5ba2b82270d658464d78fc.png";